﻿@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/spacing.module.less';
@import '../../../../../constants/screen-width-breakpoints.module.less';

.setting-item {
  justify-content: space-between;
  align-items: center;
  gap: @space-24;
  margin-bottom: @space-24;
  padding-bottom: @space-16;
  border-bottom: 1px solid var(--grey-300);

  &:last-child {
    margin-bottom: @space-0;
    padding-bottom: @space-0;
    border-bottom: none;
  }
}
.setting-title {
  font-weight: 400;
  margin-bottom: @space-0;
  flex: 1;
}

.setting-description {
  line-height: 1.4;
}

.setting-control {
  flex-shrink: 0;
  justify-content: flex-end;
  align-items: center;
}

@media @tablet, @mobile {
  .setting-item {
    flex-direction: column;
    align-items: flex-start;
    gap: @space-12;
  }

  .setting-control {
    width: 100%;
    min-width: auto;
    justify-content: flex-start;
  }
}
